import { WaitingQueueEvent } from '@/views/checkout/interfaces';

export const PAYMENT_DELAY_1: WaitingQueueEvent = {
    id: 'payment_delay_1',
    message: 'common:waitingQueueTitle.payment_delay_1',
    interval: 6_000
};

export const PAYMENT_DELAY_2: WaitingQueueEvent = {
    id: 'payment_delay_2',
    message: 'common:waitingQueueTitle.payment_delay_2',
    interval: 20_000
};

export const PAYMENT_WAITING_QUEUE_EVENTS: Array<WaitingQueueEvent> = [
    PAYMENT_DELAY_1,
    PAYMENT_DELAY_2
];
